
<template>
  <modal-pop
    :opened.sync="popupOpen"
    :modalHeader="true"
    :modalFooter="true"
    :title="siteCode == $config.SITECODE_OGMMR ? '' : $t('MMAIN-06-01-01-01')"
    class="modal"
  >
    <template #content>
      <div v-if="siteCode == $config.SITECODE_OGMMR">
        <p>{{/*- This version of the application is no longer supported.*/$t("MMAIN-06-01-01-05")}}</p>
        <p>
          {{/*- Please update to the latest version from the Play Store or Apple Store to
          continue using the application with the newest features.*/$t("MMAIN-06-01-01-06")}}
        </p>
      </div>
      <div v-else>
        <p>{{/*Please update to the latest version for stable use.*/$t("MMAIN-06-01-01-02")}}</p>
      </div>
    </template>
    <template #footer>
      <button class="btn bottom positive" @click="goToMarket()">
      {{ siteCode == $config.SITECODE_OGMMR ? $t("MOTP-01-01-04-04") : $t("MMAIN-06-01-01-03") }}
      </button>
    </template>
  </modal-pop>
</template>
<script>
import { mapGetters } from "vuex";
import Common from "@/components/basic/Common";
export default {
  extends: Common,
  name: "VersionUpdatePopup",
  computed: {
    ...mapGetters("native", ["getNativeAll"]),
  },
  mounted() {
    switch (this.getNativeAll.smphMchtlDstcd) {
      case this.$config.OS_ANDROID:
        this.appVersionName = this.$config.ANDROID_APP_RECENT_VERSION;
        this.appVersionCode = this.$config.ANDROID_APP_RECENT_VERSION.replace(/\./g, "");
        break;
      case this.$config.OS_IOS:
        this.appVersionName = this.$config.IOS_APP_RECENT_VERSION;
        this.appVersionCode = this.$config.IOS_APP_RECENT_VERSION.replace(/\./g, "");
        break;
      default:
        break;
    }
    this.$log.info(this.getNativeAll.appVersionName);
    this.$log.info(this.getNativeAll.appVersionCode);
  },
  data() {
    return {
      appVersionName: this.$config.ANDROID_APP_RECENT_VERSION,
      appVersionCode: this.$config.ANDROID_APP_RECENT_VERSION.replace(/\./g, ""),
      popupOpen: false,
    };
  },
  methods: {
    checkVersion() {
      if (parseInt(this.appVersionCode) > parseInt(this.getNativeAll.appVersionName.replace(/\./g, "")) || this.getNativeAll.appVersionName == "") {
        this.popupOpen = true;
        return true;
      } else {
        return false;
      }
    },
    goToMarket() {
      this.popupOpen = false;
      this.$goToMarket(this.getNativeAll.smphMchtlDstcd);
    },
  },
};
</script>